import PropTypes from 'prop-types';
import React from 'react';

import { Label } from 'common/components/Label/Label';
import { ToggleSelect } from 'common/components/ToggleSelect/ToggleSelect';
import { H1, P } from 'common/styles/oc-styled-components';

import {
  NameBirthContainer,
  StyledAlert,
  StyledLock,
} from '../../../checkout-styled-components';
import { BirthDateFormRow } from '../../common/BirthdateFormRow/BirthdateFormRow';
import { NameFormRow } from '../../common/NameFormRow/NameFormRow';
import SexAtBirthCard from '../../common/SexAtBirthCard/SexAtBirth';

const RETURNING_PATIENT_OPTIONS = {
  NO: 'I am a new patient',
  YES: 'I am a returning patient',
};

const PatientInformation = ({
  firstName,
  lastName,
  onNameChange,
  birthdate,
  onBirthdateChange,
  insurance,
  showReturningPatientToggle,
  isReturningPatient,
  onReturningPatientChange,
}) => {
  const hasInsuranceProvider = Boolean(insurance.provider);

  return (
    <section>
      <H1 fontSize="20px" margin="-12px 0 0 auto">
        Patient Information
        <StyledLock
          aria-hidden
          bottom="5px"
          margin="0 0 0 8px"
          size="16px"
          theme="filled"
          type="lock"
          role="presentation"
        />
      </H1>
      <P margin=" 0 0 10px">Who is coming in to see the dentist?</P>
      {hasInsuranceProvider 
        && (
          <StyledAlert
            data-testid="patientInformationAlert"
            display="block"
            height="auto"
            fontSize="12px"
            margin="0 0 15px"
            message="Please ensure all fields are typed exactly as listed on the patient’s insurance plan so that practice can verify your coverage."
            textAlign="center"
            type="success"
          />
        )
      }
      <NameBirthContainer flex={hasInsuranceProvider}>
        <NameFormRow
          firstName={firstName}
          lastName={lastName}
          onChange={onNameChange}
        />
        <BirthDateFormRow
          day={birthdate.day}
          month={birthdate.month}
          year={birthdate.year}
          onChange={onBirthdateChange}
        />
      </NameBirthContainer>
      <SexAtBirthCard />
      {showReturningPatientToggle 
        && (
          <ToggleSelect
            label={<Label label="Have you visited this practice before?" />}
            options={Object.values(RETURNING_PATIENT_OPTIONS)}
            value={
              isReturningPatient
                ? RETURNING_PATIENT_OPTIONS.YES
                : RETURNING_PATIENT_OPTIONS.NO
            }
            onChange={e =>
              onReturningPatientChange(
                e.target.value === RETURNING_PATIENT_OPTIONS.YES,
              )
            }
          />
        )
      }
    </section>
  );
};

PatientInformation.propTypes = {
  insurance: PropTypes.object,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  onNameChange: PropTypes.func,
  birthdate: PropTypes.objectOf(PropTypes.number),
  onBirthdateChange: PropTypes.func,
  showReturningPatientToggle: PropTypes.bool,
  isReturningPatient: PropTypes.bool,
  onReturningPatientChange: PropTypes.func,
};

export default PatientInformation;
